module.exports = __webpack_public_path__ + "static/media/text-icon.2ab395ad.svg";